/**
 * NOTE: This file can have treatments added to it, but treatments SHOULD NEVER be modified or removed.
 * This file is used to maintain treatments since the first treatment was applied.
 *
 * Treatment types can be repeated and used in a way that makes them understandable from a
 * business level.
 *
 * Treatment version should be updated when a new version of a treatment type is created. The
 * composite key (treatment type, treatment version) must be unique.
 */

import {ITreatmentTemplate} from 'core/api/prescription'

/*
 * Version 1 treatments
 */

const version1 = '1'

const MONOCULAR_CONTRAST__1: ITreatmentTemplate = {
  type: 'MONOCULAR_CONTRAST',
  version: version1,
  instructions: [
    {type: 'CONTRAST', params: {eye: '$STRONG', weight: 15}},
  ],
}

const MONOCULAR_FLICKER__1: ITreatmentTemplate = {
  type: 'MONOCULAR_FLICKER',
  version: version1,
  instructions: [
    {type: 'CONTRAST', params: {eye: '$STRONG', weight: 30}},
    {type: 'FLICKER', params: {
      eye: '$WEAK',
      startPhase: 'Normal',
      offset: 0,
      normalDuration: 100,
      proxyDuration: 100,
      proxyColor: '#000000',
    }},
  ],
}

const BINOCULAR_FLICKER__1: ITreatmentTemplate = {
  type: 'BINOCULAR_FLICKER',
  version: version1,
  instructions: [
    {type: 'FLICKER', params: {
      eye: '$STRONG',
      startPhase: 'Normal',
      offset: 0,
      normalDuration: 100,
      proxyDuration: 100,
      proxyColor: '#000000',
    }},
    {type: 'FLICKER', params: {
      eye: '$WEAK',
      startPhase: 'Normal',
      offset: 100,
      normalDuration: 100,
      proxyDuration: 100,
      proxyColor: '#000000',
    }},
  ],
}

const DICHOPTIC_PRESENTATION__1: ITreatmentTemplate = {
  type: 'DICHOPTIC_PRESENTATION',
  version: version1,
  instructions: [
    {type: 'DICHOPTIC', params: {
      primaryEye: '$WEAK',
      rotationFrequency: 10 * 1000,
    }},
    {type: 'CONTRAST', params: {
      eye: '$STRONG',
      weight: 20,
    }},
  ],
}

const PLACEBO__1: ITreatmentTemplate = {
  type: 'PLACEBO',
  version: version1,
  instructions: [
    {type: 'CONTRAST', params: {
      eye: '$STRONG',
      weight: 100,
    }},
  ],
}

const DICHOPTIC_PRESENTATION__CAM1C_1: ITreatmentTemplate = {
  type: 'DICHOPTIC_PRESENTATION',
  version: 'c-am-1c-1',
  instructions: [
    {type: 'DICHOPTIC', params: {
      primaryEye: '$WEAK',
      rotationFrequency: 30 * 1000,
    }},
    {type: 'CONTRAST', params: {
      eye: '$STRONG',
      weight: 15,
    }},
  ],
}

const BINOCULAR_INC_CONTRAST__CAM1D_1: ITreatmentTemplate = {
  type: 'BINOCULAR_INC_CONTRAST__CAM1D',
  version: version1,
  instructions: [
    {type: 'CONTRAST', params: {eye: '$STRONG', weight: '$INC_1_F'}},
    {type: 'CONTRAST', params: {eye: '$WEAK', weight: '$INC_1_A'}},
    {type: 'DICHOPTIC', params: {
      primaryEye: '$WEAK',
      rotationFrequency: 30 * 1000,
    }},
  ],
}

export type TreatmentTemplate =
  // Version 1
  typeof MONOCULAR_CONTRAST__1 | typeof MONOCULAR_FLICKER__1 | typeof BINOCULAR_FLICKER__1 |
  typeof DICHOPTIC_PRESENTATION__1 | typeof PLACEBO__1 |
  // C-AM-1C
  typeof DICHOPTIC_PRESENTATION__CAM1C_1 |
  // C-AM-1D
  typeof BINOCULAR_INC_CONTRAST__CAM1D_1

/**
 * All available treatments
 */
export const TreatmentTemplates = {
  // Version 1
  MONOCULAR_CONTRAST__1,
  MONOCULAR_FLICKER__1,
  BINOCULAR_FLICKER__1,
  DICHOPTIC_PRESENTATION__1,
  PLACEBO__1,
  // C-AM-1C
  DICHOPTIC_PRESENTATION__CAM1C_1,
  // C-AM-1D
  BINOCULAR_INC_CONTRAST__CAM1D_1,
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/treatment/treatments.ts